module.exports = __webpack_public_path__ + "img/intro3.8be2734d.png";